import { useEffect } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import { validateAmount } from '#src/app/shared/utils/payments';

import { useMembershipModalState } from '../../../modalContext';

export function useRealtimeValidation(): void {
	const [{ amount, minAmount, maxAmount, currencyCode, acceptMembership }, { setValidationErrors }] =
		useMembershipModalState();
	const { translate, typedTranslate, localizeCurrency } = useI18n();

	useEffect(() => {
		if (!acceptMembership) {
			setValidationErrors(null);
			return;
		}

		const result = validateAmount({
			amount,
			minimumAmount: minAmount,
			maximumAmount: maxAmount,
		});
		if (result) {
			setValidationErrors({
				amount: typedTranslate(result, {
					minimumAmount: localizeCurrency(minAmount, currencyCode),
					maximumAmount: localizeCurrency(maxAmount, currencyCode),
				}),
			});
		} else {
			setValidationErrors(null);
		}
	}, [
		amount,
		maxAmount,
		minAmount,
		setValidationErrors,
		translate,
		typedTranslate,
		localizeCurrency,
		currencyCode,
		acceptMembership,
	]);
}
